import clsx from 'clsx';
import {
  IN_APPROVAL_PAYMENT_STATUS_COLOR,
  IN_REVIEW_PAYMENT_STATUS_COLOR,
  NEW,
  SUCCESS_PAYMENT_STATUS_COLOR
} from '../../resources/constants';
import { CLAIM_STAGES } from '../../resources/enums';
import { BellPlus, CheckCircle, ClipboardCheck, Clock8, FileText, Hammer, Inbox, MailCheck, MailOpen, PenLine, Search, Send, Settings } from 'lucide-react';
import { capitalizeSentence } from '../../utils/miscFunctions';

interface IClaimStagesProps {
  status: CLAIM_STAGES | string;
  classes?: string;
}

const ClaimStages = ({ status, classes }: IClaimStagesProps): JSX.Element => {

  const getStatusIcon = (status: string | null | boolean) => {

    switch (status) {
      case CLAIM_STAGES.NEW || status === 'New':
        return <BellPlus className="inline-block w-4 h-4 mr-1" />;
      case CLAIM_STAGES.IN_REVIEW || status === 'In_review' || status === 'In Review':
        return <Search className="inline-block w-4 h-4 mr-1" />;
      case CLAIM_STAGES.SUBMITTED || status === 'Submitted':
        return <Inbox className="inline-block w-4 h-4 mr-1" />;
      case CLAIM_STAGES.ACKNOWLEDGED || status === 'Acknowledged':
        return <MailCheck className="inline-block w-4 h-4 mr-1" />;
      case CLAIM_STAGES.ASSESSED || status === 'Assessed':
        return <ClipboardCheck className="inline-block w-4 h-4 mr-1" />;
      case CLAIM_STAGES.ADJUSTED || status === 'Adjusted':
        return <Hammer className="inline-block w-4 h-4 mr-1" />;
      case CLAIM_STAGES.DV_ISSUED || status === 'Dv_issued':
        return <FileText className="inline-block w-4 h-4 mr-1" />;
      case CLAIM_STAGES.DV_SIGNED || status === 'Dv_signed':
        return <PenLine className="inline-block w-4 h-4 mr-1" />;
      case CLAIM_STAGES.PAID || status === 'Paid':
        return <CheckCircle className="inline-block w-4 h-4 mr-1" />;

      default:
        break;
    }
  }



  return (
    <div className="w-full flex ">
      <span
        className={clsx(
          'w-fit whitespace-nowrap  h-[24px] !rounded-full !text-xs gap-[2px] px-2 flex items-center justify-start',
          {
            // New claims
            [NEW]: status === CLAIM_STAGES.NEW || status === 'New',

            // In review by Brolly
            [IN_REVIEW_PAYMENT_STATUS_COLOR]: status === CLAIM_STAGES.IN_REVIEW || status === 'In_review' || status === 'In Review',

            // Submitted to insurer
            [IN_APPROVAL_PAYMENT_STATUS_COLOR]: status === CLAIM_STAGES.SUBMITTED || status === 'Submitted',

            // Acknowledged by insurer
            'bg-[#FFD700] text-black': status === CLAIM_STAGES.ACKNOWLEDGED || status === 'Acknowledged',

            // Assessed by insurer
            'bg-[#87CEEB] text-black': status === CLAIM_STAGES.ASSESSED || status === 'Assessed',

            // Adjusted by insurer
            'bg-[#9370DB] text-white': status === CLAIM_STAGES.ADJUSTED || status === 'Adjusted',

            // DV (Discharge Voucher) issued
            'bg-[#20B2AA] text-white': status === CLAIM_STAGES.DV_ISSUED || status === 'Dv_issued',

            // DV signed by customer
            'bg-[#4682B4] text-white': status === CLAIM_STAGES.DV_SIGNED || status === 'Dv_signed',

            // Claim paid
            [SUCCESS_PAYMENT_STATUS_COLOR]: status === CLAIM_STAGES.PAID || status === 'Paid',
          },
          classes
        )}>
        {getStatusIcon(status)} {capitalizeSentence(status)}
      </span>
    </div>
  );
};

export default ClaimStages;
